import { render, staticRenderFns } from "./training-record.vue?vue&type=template&id=36937ff9&scoped=true&"
import script from "./training-record.vue?vue&type=script&lang=js&"
export * from "./training-record.vue?vue&type=script&lang=js&"
import style0 from "./training-record.vue?vue&type=style&index=0&id=36937ff9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36937ff9",
  null
  
)

export default component.exports